/* eslint-disable react/jsx-fragments */
import React, {
  Fragment,
  PureComponent,
  Children,
  isValidElement
} from "react";
import PropTypes from "prop-types";
import { gatherClasses } from "../../lib/utils";
import {
  DISPLAY_NAME_HEADER,
  DISPLAY_NAME_BREADCRUMB,
  DISPLAY_NAME_TITLE,
  DISPLAY_NAME_ACTIONS
} from "./constants";

class PageHeader extends PureComponent {
  resolveComponents() {
    let breadcrumb = null;
    let title = null;
    let actions = null;
    const { children } = this.props;

    Children.forEach(children, child => {
      if (isValidElement(child)) {
        if (child.type.displayName === DISPLAY_NAME_BREADCRUMB) {
          breadcrumb = child;
        } else if (child.type.displayName === DISPLAY_NAME_TITLE) {
          title = child;
        } else if (child.type.displayName === DISPLAY_NAME_ACTIONS) {
          actions = child;
        }
      }
    });

    return { title, breadcrumb, actions };
  }

  render() {
    const { breadcrumb, title, actions } = this.resolveComponents();
    const { dataTestId } = this.props;
    return (
      <Fragment>
        <div
          data-testid={dataTestId}
          className={gatherClasses(this.props, "oui-page-header")}
        >
          {(breadcrumb !== null || title !== null) && (
            <div className="oui-header-left">
              {breadcrumb}
              {title}
            </div>
          )}
          {actions}
        </div>
      </Fragment>
    );
  }
}

PageHeader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  dataTestId: PropTypes.string
};

PageHeader.defaultProps = {
  dataTestId: "orion-page-header"
};

PageHeader.displayName = DISPLAY_NAME_HEADER;

export default PageHeader;
